import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RefreshIdentifier } from '../enums/refresh-identifier.enum';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';
import { NotificationRequest } from '../models/notification-request.model';
import { Refresh } from '../interfaces/services/notification.interface';
import { CloudAuthenticationService } from './cloud-authentication.service';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CloudRefreshService implements Refresh {

  identifierDictionary: { [id: number]: NotificationRequest } = {};
  refreshSubjects: { [id: number]: Subject<any> } = {};
  environmentIds: number[] = [];
  authStatus: boolean;
  interval: any;
  refreshSubject = new Subject<any>();
  startProcessRefreshService:boolean  = false
  unsubscribeAuthenticationStatus = new Subject<boolean>();
  constructor(private httpService: HttpService, private authSvc: CloudAuthenticationService) {
    authSvc.authenticationStatus.pipe(takeUntil(this.unsubscribeAuthenticationStatus)).subscribe(status => {
      this.authStatus = status;
    });
    this.startProcessRefreshService = true
    this.processRequest()
  }

  get refreshServiceStarted() {
    return !!this.interval;
  }

  stopRefreshService() {
    clearInterval(this.interval);
    this.interval = null;
    this.startProcessRefreshService = false
    this.unsubscribeAuthenticationStatus.next(null);
    this.unsubscribeAuthenticationStatus.complete();
  }

  startRefreshService() {
    this.startProcessRefreshService = true
    this.processRequest()

  }

  register<T>(identifier: RefreshIdentifier, params: any, refreshInterval?: number): Subject<T> {
    const req: NotificationRequest = new NotificationRequest();
    req.notificationType = identifier;
    req.data = params;
    req.refreshInterval = refreshInterval > environment.refresh_view_delay / 10 ? refreshInterval : req.refreshInterval;
    if (!(identifier in this.identifierDictionary)) {
      this.identifierDictionary[identifier] = req;
      if (!(identifier in this.refreshSubjects)) {
        this.refreshSubjects[identifier] = new Subject<T>();
      }
    }
    return this.refreshSubjects[identifier];
  }

  unregister(identifier: RefreshIdentifier) {
    this.refreshSubjects[identifier]?.unsubscribe();
    delete this.refreshSubjects[identifier];
    delete this.identifierDictionary[identifier];
  }

  getRefreshSubject<T>(identifier: RefreshIdentifier): Subject<T> {
    if (!(identifier in this.refreshSubjects)) {
      this.refreshSubjects[identifier] = new Subject<T>();
    }
    return this.refreshSubjects[identifier];
  }

  processRequest() {
    if (!this.authStatus || !this.startProcessRefreshService) {
      return;
    }
    const requestList = this.getRequestList();
    const token = this.authSvc.getToken();
    if (requestList.length > 0 && token) {
      this.httpService.post(environment.api.routes.refresh_service, requestList).subscribe(res => {
        const currentTime = new Date();
        this.refreshSubject.next(res);
        Object.entries(res).forEach(([key, value]) => {
          if (this.refreshSubjects[key]) {
            this.refreshSubjects[key].next(value);
            this.identifierDictionary[key].lastUpdateTime = currentTime;
          }
        });
        if(this.startProcessRefreshService){
          setTimeout(()=>this.processRequest(),environment.refresh_view_delay)
        }
      });
    } else {
      if(this.startProcessRefreshService){
        setTimeout(()=>this.processRequest(),environment.refresh_view_delay)
      }
    }

  }

  getRequestList(): NotificationRequest[] {
    const identifierList: NotificationRequest[] = [];
    const currentTime = new Date().getTime();
    Object.values(this.identifierDictionary).forEach(value => {
      const secondDifference = Math.ceil(Math.abs((currentTime - new Date(value.lastUpdateTime).getTime()) / 1000));
      if (secondDifference > value.refreshInterval) {
        identifierList.push(value);
      }
    });
    return identifierList;
  }

  getRefresh() {
    return this.refreshSubject.asObservable();
  }
}
